import React, { useState, useEffect, } from "react";
import { navigate } from "@reach/router";
import { InputGroup, InputLabel, InputText, useLoaderButton, useNotificationsCtx, TNotificationType, } from "@gw/component-library";
import { useBNIdentity } from "@gw/bn-identity";
var CompleteRegistrationForm = function (_a) {
    var _b = _a.codeParam, codeParam = _b === void 0 ? "" : _b, _c = _a.emailParam, emailParam = _c === void 0 ? "" : _c;
    var _d = useState(emailParam), email = _d[0], setEmail = _d[1];
    var code = useState(codeParam)[0];
    var _e = useState(""), pwd = _e[0], setPwd = _e[1];
    var _f = useState(""), pwdRep = _f[0], setPwdRep = _f[1];
    var _g = useLoaderButton({}), LoaderButton = _g.LoaderButton, enableButton = _g.enableButton, disableButton = _g.disableButton, setLoadingButton = _g.setLoadingButton;
    var completeRegistration = useBNIdentity().completeRegistration;
    var addNotification = useNotificationsCtx().addNotification;
    useEffect(function () {
        if (![email.trim(), code.trim(), pwd.trim(), pwdRep.trim()].includes("") &&
            pwd === pwdRep) {
            enableButton();
        }
        else {
            disableButton();
        }
    }, [email, code, pwd, pwdRep]);
    var onChangeCb = function (ev, setter) {
        var val = ev.target.value;
        setter(val);
    };
    var onSubmitCb = function () {
        setLoadingButton();
        completeRegistration(email, code, pwd, pwdRep)
            .then(function (user) {
            addNotification("Account Confirmed! Redirecting to login in 5 seconds.", TNotificationType.success);
            window.setTimeout(function () {
                navigate("/?email=" + user.email);
            }, 5000);
        })
            .catch(function (err) {
            addNotification("Invalid code provided, please request a code again.", TNotificationType.error);
            enableButton();
        });
    };
    return (React.createElement("form", { className: "complete-reg-form" },
        React.createElement(InputGroup, null,
            React.createElement(InputLabel, { htmlFor: "email" }, "Email:"),
            React.createElement(InputText, { value: email, name: "email", placeholder: "user@domain.com", type: "email", onChange: function (ev) {
                    onChangeCb(ev, setEmail);
                } })),
        React.createElement(InputGroup, null,
            React.createElement(InputLabel, { htmlFor: "pwd" }, "Password:"),
            React.createElement(InputText, { value: pwd, name: "last", placeholder: "Password", type: "password", onChange: function (ev) {
                    onChangeCb(ev, setPwd);
                } })),
        React.createElement(InputGroup, null,
            React.createElement(InputLabel, { htmlFor: "pwdRep" }, "Re-Enter Password:"),
            React.createElement(InputText, { value: pwdRep, name: "pwdRep", placeholder: "Enter your password again", type: "password", onChange: function (ev) {
                    onChangeCb(ev, setPwdRep);
                } })),
        React.createElement("div", { className: "actions" },
            React.createElement(LoaderButton, { onClick: function (ev) {
                    onSubmitCb();
                } },
                React.createElement(React.Fragment, null, "Submit")))));
};
export default CompleteRegistrationForm;
//# sourceMappingURL=CompleteRegistrationForm.js.map